const QUERY_PARAM = "network_logging";
const LOCAL_STORAGE_KEY = "network-logging-enabled";

/**
 * Returns whether network error logging is enabled.
 *
 * Reads the `network_logging` query param and, if set, persists a flag to
 * localStorage so it survives client-side navigation
 *
 * Typically, this should be set for aphrodite launches in black-box environments
 * like Respondus LDB and Schoolyear.
 */
export function isNetworkLoggingEnabled(): boolean {
  try {
    if (new URLSearchParams(window.location.search).get(QUERY_PARAM) === "1") {
      localStorage.setItem(LOCAL_STORAGE_KEY, "1");
    }

    return localStorage.getItem(LOCAL_STORAGE_KEY) === "1";
  } catch (err) {
    console.error(err);
    return false;
  }
}
